(function () {
  var ALLOWED_COUNTRIES = ['GB', 'UK', 'US', 'CA', 'AU'];
  var UNAVAILABLE_LABEL = 'Unavailable';
  var UNAVAILABLE_MESSAGE =
    "Oops! Looks like this product isn’t available in your area just yet. We're working on it—hang tight!";

  function applyGeoPurchaseRestriction() {
    if (!window.efficGeoPurchaseRestricted) return;

    var atcButtons = document.querySelectorAll('.effic_buy_buttons .atc_button');
    var checkoutButtons = document.querySelectorAll('.effic_buy_buttons .effic_checkout_button');

    atcButtons.forEach(function (atcButton) {
      if (typeof atcButton.disabled !== 'undefined') {
        atcButton.disabled = true;
      }
      atcButton.textContent = UNAVAILABLE_LABEL;
      atcButton.style.userSelect = 'none';

      var next = atcButton.nextElementSibling;
      if (!next || !next.classList.contains('effic-geo-unavailable-msg')) {
        var message = document.createElement('p');
        message.className = 'effic-geo-unavailable-msg';
        message.textContent = UNAVAILABLE_MESSAGE;
        message.style.fontWeight = 700;
        message.style.fontSize = '14px';
        message.style.marginTop = '12px';
        atcButton.after(message);
      }
    });

    checkoutButtons.forEach(function (checkoutButton) {
      checkoutButton.remove();
    });

    // Sticky quick-add uses a separate ATC path; remove it entirely when restricted
    document.querySelectorAll('product-quick-add').forEach(function (quickAdd) {
      quickAdd.remove();
    });
  }

  window.efficApplyGeoPurchaseRestriction = applyGeoPurchaseRestriction;

  fetch('https://try.noobru.com/get-li')
    .then(function (response) {
      return response.json();
    })
    .then(function (response) {
      if (
        response &&
        response.country &&
        !ALLOWED_COUNTRIES.includes(response.country)
      ) {
        window.efficGeoPurchaseRestricted = true;
        applyGeoPurchaseRestriction();
      }
    })
    .catch(function () {
      // Geo lookup failed — leave purchase buttons available
    });

  document.addEventListener('variant:change', applyGeoPurchaseRestriction);
})();
